(() => {
  if (window.unicoColorPreviewBound) return;
  window.unicoColorPreviewBound = true;
  let pendingFrame = 0;
  const reveal = choice => {
    if (window.matchMedia('(max-width: 749px)').matches) return;
    if (!choice || choice.disabled || choice.getAttribute('aria-disabled') === 'true') return;
    const configurator = choice.closest('.unico-product, .unico-custom, unico-signastro');
    const gallery = configurator?.querySelector('[data-gallery-main], .unico-gallery__main, .u-astro__stage');
    if (!gallery) return;
    cancelAnimationFrame(pendingFrame);
    pendingFrame = requestAnimationFrame(() => {
      const header = document.querySelector('.u-header');
      const offset = Math.max(0, header?.getBoundingClientRect().bottom || 0) + 12;
      const top = Math.max(0, window.scrollY + gallery.getBoundingClientRect().top - offset);
      window.scrollTo({top, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
    });
  };
  document.addEventListener('click', event => {
    const choice = event.target instanceof Element ? event.target.closest('button[data-color-choice], button[data-color], button[data-palette], button[data-duo-color]') : null;
    reveal(choice);
  });
  document.addEventListener('change', event => {
    const choice = event.target instanceof Element ? event.target.closest('.u-astro__values--colors input[type="radio"]') : null;
    reveal(choice);
  });
})();

